import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default {
  state: {
    screenWidth: undefined,
    isMobile: false,
    elSize: "small",
    vxeSize: "medium",
  },
  getters: {
    isMobile: (state) => state.isMobile,
    elSize: (state) => state.elSize,
    vxeSize: (state) => state.vxeSize,
    screenWidth: (state) => state.screenWidth,
  },
  mutations: {
    setIsMobile(state, isMobile) {
      state.isMobile = isMobile;
    },
    setElSize(state, elSize) {
      state.elSize = elSize;
    },
    setVxeSize(state, vxeSize) {
      state.vxeSize = vxeSize;
    },
    setScreenWidth(state, screenWidth) {
      state.screenWidth = screenWidth;
    },
  },
  actions: {
    setDevice({ commit }) {
      const width = document.documentElement.clientWidth;
      commit("setScreenWidth", width);
      commit("setIsMobile", width < 768);
      commit("setElSize", width < 426 ? "mini" : "small");
      commit("setVxeSize", width < 426 ? "small" : "medium");
    },
  },
};
